import React from 'react';
import webapi from '../../../api/webapi';
import SurfBody from './SurfBody';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

class Surf extends React.Component {
    state = { languageInfo: '' }
    
    componentDidMount(){
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('langFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('langFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.languageInfo);
        }else{
            this.setState({languageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
    }

    async getLanguageInfo(LanguageCode){
        const responseResultLanguageinfo = await webapi.get('pages/languageInfo/'+LanguageCode);
        //console.log(responseResultLanguageinfo.data.length);
        //console.log(responseResultLanguageinfo.data);
        
        if (responseResultLanguageinfo!==undefined && responseResultLanguageinfo.data.length>0)
        {
            this.setState({languageInfo:responseResultLanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultLanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultLanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({languageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
    }

    render() {
        if (this.state.languageInfo) {
            return (
                <div>
                    <Header languageInfo = {this.state.languageInfo}/>
                    <SurfBody languageInfo = {this.state.languageInfo}/>
                    <Footer lang = {this.state.languageInfo[0].Code}/>
                </div>
            )
        }
        else
        {
            return (
                <div></div>
            )
        }
    }
 }

 export default Surf;